import React from 'react'
import Form from '../../../form'
import Quote from '../../../quote'

const OnlineSchool: React.FC = () => {
  return (
    <>
      <div className='onlinepbx__container'>

        <div className='onlinepbx__story'>
          <div className='onlinepbx__story__block__row onlinepbx__story__block__row__head onlinepbx__story__block__row__center'>
            <div className='onlinepbx__story__left onlinepbx__story__description'>
              <h2>
                Как онлайн-школа использует телефонию, чтобы остаться на&nbsp;плаву в&nbsp;период резкого падения спроса
              </h2>
                <div className='onlinepbx__story__text onlinepbx__story__text__head'>
                  <div className='onlinepbx__story__text__paragraph'>
                    Для компенсации низкого спроса, компания сосредоточилась на&nbsp;тщательной обработке заявок с&nbsp;помощью инструментов телефонии
                  </div>
              </div>
              <div>
                <Form text='Попробовать onlinepbx' pageName='Истории' />
              </div>
            </div>
            <div className='onlinepbx__story__right onlinepbx__story__image'>
              <img src={process.env.PUBLIC_DIR + '/images/stories/story5-big.jpg'} />
            </div>
          </div>

          <div className='onlinepbx__story__block onlinepbx__story2__block1'>
            <div>
              <h2 className='onlinepbx__content__header__center'>
                1. Настроили интеграцию телефонии с&nbsp;CRM
              </h2>
              <div className='onlinepbx__story__block__center onlinepbx__story__block__quote'>
                <Quote width='922'>
                  <>
                    <div>Клиенты забывают время и&nbsp;место встречи. Без напоминаний только часть зарегистрированных клиентов доходит до&nbsp;вебинара или открытого урока. Чуть больше&nbsp;&mdash; до&nbsp;марафона, на&nbsp;рекламу которого тратится масса усилий. Порядка&nbsp;50% заказов на&nbsp;онлайн-курсы остаются неоплаченными. Некоторые&nbsp;&mdash; потому, что люди передумали. А&nbsp;часть&nbsp;&mdash; потому, что просто забыли.</div>
                  </>
                </Quote>
              </div>
            </div>

            <div className='onlinepbx__story__block__row onlinepbx__story__block__row__center'>
              <div className='onlinepbx__story__left onlinepbx__story__image'>
                <img src={process.env.PUBLIC_DIR + '/images/stories/story5-block1.jpg'} alt=""/>
              </div>
              <div className='onlinepbx__story__right onlinepbx__story__description' >
                <div className='onlinepbx__story__block__header'>Напоминаем клиенту о&nbsp;запланированном событии</div>
                <div className='onlinepbx__story__text'>
                  <div className='onlinepbx__story__text__paragraph'>
                    В&nbsp;СRМ карточка клиента формируется автоматически при входящем звонки и&nbsp;информация не&nbsp;теряется. Так менеджер может позвонить клиенту и&nbsp;заранее напомнить о&nbsp;предстоящем уроке или вебинаре.
                  </div>
                </div>
                <div className='onlinepbx__story__block__thumb'>
                  <img src={process.env.PUBLIC_DIR + '/images/stories/thumbs-up.svg'} className='onlinepbx__story__block__thumb__icon' />
                  <div className='onlinepbx__story__text__medium'>
                    Клиент посещает событие, на&nbsp;которое записывался
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='onlinepbx__story__block onlinepbx__story2__block1'>
            <div>
              <h2 className='onlinepbx__content__header__center'>
                2. Настроили логику обработки вызовов
              </h2>
              <div className='onlinepbx__story__block__center onlinepbx__story__block__quote'>
                <Quote width='922'>
                  <>
                    <div>Менеджер пропускает входящий звонок, когда консультирует клиента в&nbsp;офисе или клиент звонит в&nbsp;нерабочее время.</div>
                  </>
                </Quote>
              </div>
            </div>

            <div className='onlinepbx__story__block__row onlinepbx__story__block__row__center'>
              <div className='onlinepbx__story__left onlinepbx__story__description' >
                <div className='onlinepbx__story__block__header'>Перезваниваем по&nbsp;всем пропущенным</div>
                <div className='onlinepbx__story__text'>
                  <div className='onlinepbx__story__text__paragraph'>
                    Если в&nbsp;нерабочее время звонящий оставил голосовое сообщение, оно приходит на&nbsp;почту ответственному, а&nbsp;пропущенные звонки фиксируются в&nbsp;CRM и&nbsp;мы&nbsp;обязательно по&nbsp;ним перезваниваем. 
                  </div>
                  <div className='onlinepbx__story__text__paragraph'>
                    Если менеджер в&nbsp;офисе не&nbsp;отвечает на&nbsp;звонок в&nbsp;течение 30&nbsp;секунд, то&nbsp;звонок переадресуется на&nbsp;мобильный номер другого менеджера. Если другой сотрудник тоже не&nbsp;берёт в&nbsp;течение 15&nbsp;секунд, то&nbsp;звонок уходит на&nbsp;следующий номер.
                  </div>
                </div>
                <div className='onlinepbx__story__block__thumb'>
                  <img src={process.env.PUBLIC_DIR + '/images/stories/thumbs-up.svg'} className='onlinepbx__story__block__thumb__icon' />
                  <div className='onlinepbx__story__text__medium'>
                    Так решаются две проблемы: не&nbsp;теряем звонки, и&nbsp;сотрудники не&nbsp;испытывают стресс от&nbsp;пропущенного звонка
                  </div>
                </div>
              </div>
              <div className='onlinepbx__story__right onlinepbx__story__image'>
                <img src={process.env.PUBLIC_DIR + '/images/stories/story5-block2.jpg'} alt=""/>
              </div>
            </div>
          </div>

          <div className='onlinepbx__story__block onlinepbx__story2__block1'>
            <div>
              <h2 className='onlinepbx__content__header__center'>
                3. Используем функцию записи звонков
              </h2>
              <div className='onlinepbx__story__block__center onlinepbx__story__block__quote'>
                <Quote width='922'>
                  <>
                    <div>У&nbsp;нас все звонки записываются и&nbsp;мы&nbsp;их&nbsp;реально слушаем, ведь это важно, что говорят сотрудники при входящих звонках и&nbsp;каким образом консультируют клиентов.</div>
                  </>
                </Quote>
              </div>
            </div>

            <div className='onlinepbx__story__block__row onlinepbx__story__block__row__center'>
              <div className='onlinepbx__story__left onlinepbx__story__image'>
                <img src={process.env.PUBLIC_DIR + '/images/stories/story5-block3.jpg'} alt=""/>
              </div>
              <div className='onlinepbx__story__right onlinepbx__story__description' >
                <div className='onlinepbx__story__block__header'>Контролируем качество консультации</div>
                <div className='onlinepbx__story__text'>
                  <div className='onlinepbx__story__text__paragraph'>
                    В&nbsp;панели управления записываются все звонки, их&nbsp;можно прослушивать в&nbsp;любой момент и&nbsp;с&nbsp;любого устройства.
                  </div>
                </div>
                <div className='onlinepbx__story__block__thumb'>
                  <img src={process.env.PUBLIC_DIR + '/images/stories/thumbs-up.svg'} className='onlinepbx__story__block__thumb__icon' />
                  <div className='onlinepbx__story__text__medium'>
                    Клиент получает актуальную и&nbsp;полную информацию по&nbsp;услугам
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='onlinepbx__story__block onlinepbx__story--mb'>
            <div className='onlinepbx__story__block__center onlinepbx__story__block__quote'>
              <Quote width='922'>
                <>
                  <div className='onlinepbx__quote__accent'>С&nbsp;инструментами телефонии мы&nbsp;знаем, почему клиенты не&nbsp;покупают полный курс после пробного, сколько процентов посетителей сайта становятся нашими клиентами и&nbsp;на&nbsp;каком этапе от&nbsp;менеджеров требуется особое внимание к&nbsp;клиентам. Мы&nbsp;отрабатываем все звонки на&nbsp;100% благодаря onlinepbx.</div>
                </>
              </Quote>
            </div>
          </div>

        </div>

      </div>

      <div className='onlinepbx__story__block__form__wrapper'>
        <h2 className='onlinepbx__content__header__center'>
          Настроим сервис <span className='onlinepbx__content__header__green'>бесплатно</span> за 30 минут!
        </h2>
        <div className='onlinepbx__story__block__form'>
          <Form free isWhite text='Подключить бесплатно' pageName='Истории' />
        </div>
      </div>
    </>
  )
}

export default OnlineSchool
